export const CONTACT_PHONE_LOCAL = "927400309";
export const CONTACT_PHONE_LABEL = "927 400 309";
export const CONTACT_PHONE_E164 = "51927400309";
export const CONTACT_PHONE_HREF = `tel:+${CONTACT_PHONE_E164}`;
export const CONTACT_WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_E164}`;
